export const GET_FEEDBACK_FORMS_CORE = 'FEEDBACK/get_feedback_forms_core';
export const GET_FEEDBACK_DATA_FOR_FEEDBACK = 'FEEDBACK/get_feedback_data_for_feedback';
export const SUBMIT_FEEDBACK = 'FEEDBACK/submit_feedback';

